import { Link } from 'react-router-dom';
import EmailSubscription from '../common/EmailSubscription';
import AffiliateDisclosure from '../common/AffiliateDisclosure';

const Footer = () => {
  return (
    <footer className="bg-dark text-white mt-5 p-4 text-center">
      {/* Email Subscription Section */}
      <div className="container mb-4" id="subscribe">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <EmailSubscription />
          </div>
        </div>
      </div>

      <div className="container-fluid text-center text-md-left">
        <div className="row">
          <div className="col-md-3 mx-auto">
            Copyright &copy; {new Date().getFullYear()}
          </div>
          <div className="col-md-3 mx-auto">
            <Link to="/tnc">Terms and Conditions</Link>
          </div>
          <div className="col-md-3 mx-auto">
            <Link to="/sellers">Sellers: promote your deals</Link>
          </div>
        </div>
        <AffiliateDisclosure className="affiliate-disclosure--footer" />
      </div>
    </footer>
  );
};

export default Footer;
